import React, { useState } from 'react';
import LexicalEditor from './LexicalEditor';
import { useDrafts } from '../contexts/DraftContext';
import { exportLexicalJsonToDraft } from '../lib/export/exportLexicalJsonToDraft';

export default function EditorDemo() {
  const { currentDraft } = useDrafts();
  const [value, setValue] = useState(currentDraft?.raw || JSON.stringify({ root: { type: 'root', version: 1, children: [{ type: 'paragraph', version: 1, indent: 0, format: '', direction: null, children: [] }], indent: 0, format: '', direction: null } }));

  return (
    <div style={{ padding: 16 }}>
      <LexicalEditor initialValue={value} onChange={setValue} />
      <button
        style={{ marginTop: 12 }}
        onClick={() => {
          const draft = exportLexicalJsonToDraft(value, currentDraft?.id || 'demo');
          // eslint-disable-next-line no-console
          console.log('Exported Draft', draft);
          alert('Exported draft logged to console');
        }}
      >
        Export JSON Draft
      </button>
    </div>
  );
}


